import { GameConstants } from "./GameConstants";
import { AudioManager } from "./AudioManager";
import { GameVars } from "./GameVars";
import IGameAPI from "./api/IGameAPI";
import MockAPI from "./api/MockGameAPI";
import { WatchDog } from "errorwatcher";
import { BootScene } from "./scenes/BootScene";
import { CANVAS } from "phaser";
declare var gamezop: any
declare var oMetaManager: any
export class GameManager {

    public static api: IGameAPI;

    public static init(): void {

        GameManager.api = new MockAPI();

        GameVars.intitialised = true;

        GameVars.speedFactor = 1;

        if (GameVars.currentScene.sys.game.device.os.desktop) {
            GameVars.scaleY = 1;
        } else {

            // GameVars.scaleY = 1;
            GameVars.currentScene.game.scale.displaySize = GameVars.currentScene.game.scale.parentSize;
            GameVars.currentScene.game.scale.refresh();

            const aspectRatio = window.innerHeight / window.innerWidth;
            // GameVars.scaleY = (GameConstants.GAME_HEIGHT / GameConstants.GAME_WIDTH) / aspectRatio;
            GameVars.scaleY = 1;
        }

        GameManager.readGameData();
    }

    public static readGameData(): void {

        GameManager.getGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            function (gameData: string): void {

                if (gameData) {
                    GameVars.gameData = JSON.parse(gameData);
                } else {
                    GameVars.gameData = {
                        muted: false,
                        highScore: 0,
                        language: "en"
                    };
                }
                // if (BootScene.currentInstance.isGameInitialized) GameManager.enterSplashScene();
                // else GameManager.startGame();
                GameManager.startGame();
            }
        );
    }

    public static setCurrentScene(scene: Phaser.Scene): void {

        GameVars.currentScene = scene;
    }

    public static async initializeGamezopSdk() {
        const thisContext = this;
        try {
            const data = await gamezop.Initialize({
                apiKey: "57d370d9-d604-4b6b-8628-95ee800b2386",
                debug: true,
                gameCode: "r1zG1h6m90H",
                gameInit: (initDetails: any) => {
                    if (initDetails.matchId === "") {
                        console.warn("No match found");
                        return;
                    }
                    else if (initDetails.matchId === "matchId") {
                        GameManager.resetGame();
                        return;
                    }
                    GameVars.isBattleWin = false;
                    GameVars.battleOrbData = JSON.parse(initDetails.gameConfig);
                    if (GameVars.gameOver) {
                        GameManager.resetGame();
                        return;
                    }
                    setTimeout(() => {
                        this.enterBoardScene()
                    }, 250);
                },
                gameContinue: () => {
                    if (GameVars.gameOver) {
                        GameManager.resetGame();
                        return;
                    }
                },
                gameEnd: () => {
                    //@ts-ignore
                    // GameVars.currentScene?.onGameOver()
                    GameVars.isBattleWin = true;
                    if (gamezop.data.state === "over") {
                        return;
                    }
                    gamezop.setState({
                        score: GameVars.candyEngine.score,
                        fps: Math.floor(GameVars.currentScene.game.loop.actualFps),
                        state: "over",
                        tcount: GameVars.tc,
                        kcount: GameVars.kc,
                        metadata: oMetaManager.meta
                    })
                },
                mute: () => {
                    AudioManager.mute();
                },
                pause: () => {
                    GameVars.currentScene.scene.pause(GameVars.currentScene.scene.key);
                },
                play: () => {
                    GameVars.currentScene.scene.resume(GameVars.currentScene.scene.key);
                },
                unmute: () => {
                    AudioManager.unmute();
                },
                getGameConfig: () => {
                    return GameVars.getGameConfig();
                }
            });
            // const sdkData = await prototypingGame(data);
            await thisContext.onSdkInitialize(data, thisContext);
        } catch (e) {
            console.log("Game can't load due to ", e);
        }
    }

    private static async onSdkInitialize(sdkData: any, thisContext: any) {
        if (sdkData) {
            // NetworkManager.init(); // Init should be always there.
            // TODO => have to put an isBattle check here
            console.log("Sdk initialized");
            oMetaManager.sync();
            // await BattleUtils.setPlayerData();
            if (gamezop.isBattleGame()) {
                WatchDog.init("CandyFiesta", "0.0.2", "https://collector.skillclash.com/c/events/game/");
                //   NetworkManager.connect();
                // 	const battleGameInfo: IIsBattleGameInfo = gamezop.isBattleGame();
                // 	BattleUtils.setBattleProperties(battleGameInfo);
            }
            //   const c = await import('../scenes/preloader');
            //   GameVars.currentScene.scene.add(SceneKeys.PreloaderScene, c.PreloaderScene, false);
            //   GameVars.currentScene.scene.start(SceneKeys.PreloaderScene);
            return;
        }
    }

    public static onGameAssetsLoaded(): void {

        AudioManager.init();

        GameVars.gameText = GameVars.currentScene.cache.json.get("game-text");

        GameManager.enterSplashScene();

    }

    public static enterReplayScene(): void {

        GameVars.currentScene.scene.start("ReplayScene");
    }

    public static enterSplashScene(): void {

        GameVars.currentScene.scene.start("SplashScene");
    }

    public static async onClickPlaySplash(): Promise<void> {

        GameManager.enterBoardScene();
    }

    public static onLoginSuccess(): void {

        GameManager.enterBoardScene();
    }

    public static enterBoardScene(forcedCombo?: string): void {
        GameVars.tc = GameVars.kc = 0;
        gamezop.setState({
            score: 0,
            afps: Math.floor(GameVars.currentScene.game.loop.actualFps),
            state: "playing",
            tcount: 0,
            kcount: 0
        })
        GameVars.forcedCombo = forcedCombo || null;

        (async () => {

            GameVars.seed = GameVars.firstSeed = await GameManager.api.fetchFirstSeed(GameVars.id);

            GameVars.currentScene.scene.start("BoardScene");

        })();
    }

    public static fecthSeed(): void {

        GameManager.api.fetchSeed(GameVars.id, GameManager.getSeed, GameManager);
    }

    public static getSeed(seed: any): void {

        console.log("GET SEED: " + seed);

        GameVars.seed = seed;
    }

    public static resetGame(): void {

        GameManager.enterBoardScene();
    }

    public static onBothOrbsSelected(): void {

        GameVars.iPRNG = GameVars.candyEngine.prng.i;
        GameVars.numOrbs = GameVars.candyEngine.numOrbs;
    }

    public static getTimeUntilEndOfDay(): number {

        const d = new Date();
        const h = d.getUTCHours();
        const m = d.getUTCMinutes();
        const s = d.getUTCSeconds();

        return (24 * 60 * 60) - (h * 60 * 60) - (m * 60) - s;
    }

    public static onGameOver(): void {
        if (GameVars.candyEngine.score > GameVars.gameData.highScore) {
            GameVars.gameData.highScore = GameVars.candyEngine.score;

            GameManager.writeGameData();
        }
    }

    public static onPaymentDone(transaction_id?: string): void {
        //
    }

    public static writeGameData(): void {

        GameManager.setGameStorageData(
            GameConstants.SAVED_GAME_DATA_KEY,
            GameVars.gameData,
            function (): void {
                GameManager.log("game data successfully saved");
            }
        );
    }

    public static log(text: string, error?: Error): void {

        if (!GameConstants.VERBOSE) {
            return;
        }

        if (error) {
            console.error(text + ":", error);
        } else {
            console.log(text);
        }
    }

    public static toggleOrbsSpeed(): void {

        GameVars.speedFactor = GameVars.speedFactor === 1 ? .1 : 1;
    }

    public static logBoard(str?: boolean): void {

        const board = GameVars.candyEngine.board;

        if (str) {

            const orbIDs: number[][] = [];
            const orbTypes: number[][] = [];

            for (let c = 0; c < GameVars.cols; c++) {
                orbIDs.push([]);
                for (let r = 0; r < GameVars.rows; r++) {
                    orbIDs[c][r] = board[c][r].color;
                }
            }

            for (let c = 0; c < GameVars.cols; c++) {
                orbTypes.push([]);
                for (let r = 0; r < GameVars.rows; r++) {
                    orbTypes[c][r] = board[c][r].type;
                }
            }

            console.log(JSON.stringify(orbIDs));
            console.log(JSON.stringify(orbTypes));
            console.log("seed:", GameVars.seed);
            console.log("iPRNG:", GameVars.candyEngine.prng.i);
            console.log("numOrbs:", GameVars.candyEngine.numOrbs);

        } else {

            for (let r = 0; r < GameVars.rows; r++) {

                let str = "";

                for (let c = 0; c < GameVars.cols; c++) {

                    if (board[c][r].color === -1) {
                        str += "| " + "*";
                    } else {
                        str += "| " + board[c][r].color;
                    }
                }
            }
        }
    }

    public static cloneOrbs(orbs: Candy.OrbData[][]): Candy.OrbData[][] {

        const clonedOrbs: Candy.OrbData[][] = [];

        const cols = orbs.length;
        const rows = orbs[0].length;

        for (let c = 0; c < cols; c++) {
            clonedOrbs.push([]);
            for (let r = 0; r < rows; r++) {
                clonedOrbs[c][r] = { id: orbs[c][r].id, color: orbs[c][r].color, type: orbs[c][r].type, prevPos: orbs[c][r].prevPos, mutated: orbs[c][r].mutated, removed: orbs[c][r].removed };
            }
        }

        return clonedOrbs;
    }

    public static generateBoardFromString(colorStr: string, typesStr?: string): Candy.OrbData[][] {

        const orbs: Candy.OrbData[][] = [];

        const tmpColours = JSON.parse(colorStr);

        let tmpTypesMatrix: number[][] = [];

        if (typesStr) {
            tmpTypesMatrix = JSON.parse(typesStr);
        }

        const cols = tmpColours.length;
        const rows = tmpColours[0].length;

        for (let c = 0; c < cols; c++) {
            orbs.push([]);
            for (let r = 0; r < rows; r++) {

                if (tmpTypesMatrix.length > 0) {
                    orbs[c].push({ id: c * rows + r, color: tmpColours[c][r], type: tmpTypesMatrix[c][r], prevPos: { c: c, r: r }, mutated: false, removed: false });
                } else {
                    orbs[c].push({ id: c * rows + r, color: tmpColours[c][r], type: 0, prevPos: { c: c, r: r }, mutated: false, removed: false });
                }
            }
        }

        return orbs;
    }

    public static startGame(): void {

        GameVars.currentScene.scene.start("PreloadScene");
    }

    private static getGameStorageData(key: string, successCb: Function): void {

        const gameDataStr = localStorage.getItem(key);
        successCb(gameDataStr);
    }

    private static setGameStorageData(key: string, value: any, successCb: Function): void {

        localStorage.setItem(key, JSON.stringify(value));
        successCb();
    }
}
